// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3nn1m","productName":"Table_productName__1h-Z9"};